var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",style:({ backgroundImage: `url(${require('@/assets/imge2.webp')})`})})
}
var staticRenderFns = []

export { render, staticRenderFns }